import React from "react";
import { Step } from "./types";
import clsx from "clsx";
import styles from "./FareInfographic.module.scss";

export type FareInfographicStepProps = Step;

export const FareInfographicStep: React.FC<FareInfographicStepProps> = (
  props
) => {
  return props.inclusions.map((i) => (
    <li
      key={i._id}
      className={clsx(styles.step, {
        [styles.disabled]: props.type == "disabled"
      })}
    >
      {i.infographicTitle}
      {i.footnote && <div className={styles.stepFootnote}>{i.footnote}</div>}
    </li>
  ));
};
